import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { IconImg, TextP } from '../../..';
import { __ } from 'react-i18n';

interface Props {
  watchDogOpen?: () => void;
}

function Watching({ watchDogOpen }: Props) {
  return (
    <Wrapper onClick={watchDogOpen}>
      <IconImg src={'/assets/dsi/dog.svg'} />
      <StyledTextP>{__(`Strážny pes`)}</StyledTextP>
    </Wrapper>
  );
}

const Wrapper = styled(Button)`
  width: 100%;
  min-width: ${rem(110)};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: ${rem(16)};
  padding: ${rem(8)} ${rem(32)};
`;

const StyledTextP = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  margin-left: ${rem(8)};
`;

export { Watching };
